  $(document).ready(function(){
    /* team */
    if($(".about-team").length > 0) {
      let documentWidth = $(document).width();
      console.log($(".about-team__list").width() + '--' + $(".about-team__list").height());
      let parentSizeW =  $(".about-team__list").width();
      let sizeModal = {"itemWidth": "", "itemHeight": "", "defaultWidth": "", "defaultHeight": ""};

      $(".about-team__card").each(function(indx, element){
          let currentElement = $(this);
          let currentParent = currentElement.closest(".about-team__item");
          if(currentElement.width() > sizeModal.defaultWidth) sizeModal.defaultWidth = $(this).width();
          // if(documentWidth > 560) {
              if(currentElement.height() > sizeModal.defaultHeight) sizeModal.defaultHeight = $(this).height();
          // } else {
          //     // currentParent.css({"background": "#f0f"});
          //     // console.log($(".about-team__modal-img").height() );
          //     console.log( "--" + $(".about-team__modal-header", currentParent).innerHeight() );
          //     let currentHeight = $(".about-team__modal-img img", currentParent).height() + $(".about-team__modal-content", currentParent).height();
          //     if( currentHeight  > sizeModal.defaultHeight ) sizeModal.defaultHeight = currentHeight;
          //     console.log(currentHeight);
          //     // sizeModal.defaultHeight = currentHeight;
          // }
          
      });
      $(".about-team__modal").css({"width":  sizeModal.defaultWidth, "height":  sizeModal.defaultHeight});

      if(documentWidth > 980) {
          sizeModal.itemWidth = parentSizeW/3*2 - 15;
          sizeModal.itemHeight = sizeModal.defaultHeight*2 + 30;
      } else {

          sizeModal.itemWidth = (documentWidth > 480)? (parentSizeW - 30): parentSizeW;
          if(documentWidth > 560) {
              sizeModal.itemHeight = sizeModal.defaultHeight*2 + 30;
          } else {
              sizeModal.itemHeight = sizeModal.defaultHeight*2.5;
          }
          
      }

      $(".about-team__card").click(function() {
          if($('.about-team').hasClass("about-team--active")) return;
          let currentParent = $(this).closest(".about-team__item");

          // console.log(sizeModal.itemWidth + "--" + sizeModal.itemHeight);
          // console.log($(this).offset().left);
          // console.log(sizeModal.defaultWidth + "==" + parentSizeW + "--" + currentParent.offset().left)


          $('.about-team').addClass("about-team--active");
          $(".about-team__modal", currentParent).css({ "display": "block", "z-index": 4});

          setTimeout(function() {
              currentParent.css({ "overflow": "initial"});
              if(documentWidth > 480) {
                  if((parentSizeW - currentParent.offset().left ) - 20 < sizeModal.defaultWidth) {
                      $(".about-team__modal", currentParent).css({ "left": -1*sizeModal.defaultWidth - 30});
                  }
              } else {
                  $(".about-team__modal", currentParent).css({ "left": "-15px"});
              }

              currentParent.addClass("about-team__item--active");

          }, 300);
          $(".about-team__modal", currentParent).css({ "width": +sizeModal.itemWidth, "height": sizeModal.itemHeight});
      });

      $(".about-team__modal-nav").click(function() {
          let currentParent = $(this).closest(".about-team__item");

          $('.about-team').removeClass("about-team--active");
          $('.about-team__item').removeClass("about-team__item--active");

          $(".about-team__modal", currentParent).css({"width":  sizeModal.defaultWidth, "height":  sizeModal.defaultHeight});
          $(".about-team__modal", currentParent).css({ "left": 0});

          setTimeout(function() {
              $(".about-team__modal", currentParent).css({ "display": "none", "z-index": 1});
              currentParent.css({ "overflow": "hidden"});
          }, 1000);
      });
    }

    const filterBox = document.querySelectorAll('.about-team__popup');
    if(document.querySelector('.about-team__list')) {
        document.querySelector('.about-team__list').addEventListener('click', (event) => {
            if (event.target.tagName !== 'IMG') return false;
            let filterClass = event.target.dataset['f'];
            console.log(filterClass);
            filterBox.forEach(elem => {
                elem.classList.remove('active__team_popup');
                if (elem.classList.contains(filterClass)) {
                    elem.classList.add('active__team_popup');
                }
                else{
                    elem.classList.remove('active__team_popup');
                }
            });
        });
    }

    $('.about-team__modal-buttonTop').click(function (event){
        $('.active__team_popup,body').removeClass('active__team_popup');
    });

     $('.about-team__list img').click(function (event){
        $('body').addClass('active__team_popup');
    });
  });